import { width } from "dom7";
export const symbology =  [
        {
            id: 4,
            legendName:'Puntos de calor',
            name:'P. Calor Histórico',
            legend:[{key:'Diurnos',color:'#ebed04'},{key:'Nocturnos',color:'rgba(242, 26, 15, 1)'}]
        },
        {
            id:5,
            legendName:'Clúster de puntos</br> de calor de 48 hrs.',
            legend:[
            {key:'Polígonos de clústeres',color:'#b07d40'}
            ]
        },
        {
            id:6,
            legendName:'Polígonos de puntos</br> de calor estables',
            legend:[
                {key:'Industria',color:'#026eff'},
                {key:'Volcanes',color:'#a65304'},
                {key:'Poblados',color:'#7df8dd'},
                {key:'Otros',color:'#fcfe76'},
            ]
        },
        {
            id:7,
            legendName:'Puntos de calor</br>(GOES-19(ABI))',
            legend:[
                {key:'Puntos de calor última hora',color:'#fe0100'}
            ]
        },
        {
            id:8,
            legendName:'Puntos de calor</br>GOES-19(ABI)',
            legend:[
                {key:'Densidad de puntos (24h)',color:'#fe0100'}
            ]
        },
        {
            id:9,
            legendName:'Puntos de calor</br>GOES-19(ABI)',
            legend:[
                {key:'Clúster de puntos(24h)</br>Fuente:lanot.unam.mx',color:'#fe0100'}
            ]
        },
        {
            id:10,
            legendName:'% de humedad de<br>combustible muerto',
            legend:[
                {key:'0',color:'#ffffff'},
                {key:'1-3',color:'#ffff73'},
                {key:'3-5',color:'#ffffbe'},
                {key:'5-8',color:'#beffe8'},
                {key:'8-11',color:'#bee8ff'},
                {key:'11-15',color:'#00c3ff'},
                {key:'15-21',color:'#006eff'},
                {key:'21-25',color:'#004da8'},
                {key:'> 25',color:'#002673'}
            ]
        },
        {
            id:11,
            legendName:'Anomalías de la vegetación',
            legend:[
                {key:'Sin vegetación',color:'#ffffff'},
                {key:'Sin anomalía',color:'#89cd63'},
                {key:'Baja',color:'#cfff75'},
                {key:'Moderada',color:'#fdff75'},
                {key:'Alta',color:'#ffa900'},
                {key:'Muy alta',color:'#fe0100'},
                {key:'Sin datos',color:'#cccccc'}
            ]
        },
        {
            id:12,
            legendName:'Últimas imagénes recibidas',
            legend:[
                {key:'Mosaico MODIS en falso color con</br>resolución de 250 metros (RGB:7,2,1)',color:''}
            ]
        },
        {
            id:13,
            legendName:'Últimas imagénes recibidas',
            legend:[
            {key:'Mosaico VIIRS en falso color con</br>resolución de 375 metros (RGB:l-11,l-02,l-01).',color:''}
            ]
        },
        {
            id:14,
            legendName:'Últimas imagénes recibidas',
            legend:[
            {key:'Mosaico VIIRS en color verdadero con</br>resolución de 375 metros (RGB:l-11,l-02,l-01).',color:''}
            ]
        },
        {
            id:15,

        },
        {
            id:16,
            legendName:'Áreas quemadas</br>Compuesto de áreas quemadas (Frecuencia)',
            legend:[
                {key:'0.01-0.05',color:'#f6d400'},
                {key:'0.051-0.06',color:'#f4c400'},
                {key:'0.061-0.018',color:'#f69301'},
                {key:'0.19-0.24',color:'#f56300'},
                {key:'0.25-0.38',color:'#f53100'},
                {key:'0.39-1.0',color:'#f40000'}
            ]
        },
        {
            id:17,
            legendName:'Áreas quemadas</br>Compuesto de áreas quemadas (Frecuencia)',
            legend:[
            {key:'0.01-0.05',color:'#f6d400'},
            {key:'0.051-0.06',color:'#f4c400'},
            {key:'0.061-0.018',color:'#f69301'},
            {key:'0.19-0.24',color:'#f56300'},
            {key:'0.25-0.38',color:'#f53100'},
            {key:'0.39-1.0',color:'#f40000'}
            ]
        },
        {
            id:18,
            legendName:'Cobertura de suelo',
            legend:[
            {key:'Bosque de coníferas',color:'#003d01'},
            {key:'Bosque de latifoliadas',color:'#016300'},
            {key:'Bosque mixto',color:'#5c752b'},
            {key:'Matorral',color:'#b39e2b'},
            {key:'Pastizal',color:'#e7dc5e'},
            {key:'Humedal',color:'#69a388'},
            {key:'Suelo agrícola',color:'#e7ae67'},
            {key:'Cuerpo de agua',color:'#4c70a4'},
            {key:'Asentamientos humanos',color:'#db2126'}
            ]
        },
        {
            id:19,
            legendName:'Índice de amenaza</br>a la biodiversidad',
            legend:[
            {key:'Muy Bajo',color:'#266b00'},
            {key:'Bajo',color:'#94bd00'},
            {key:'Medio',color:'#ffff00'},
            {key:'Alto',color:'#fe9900'},
            {key:'Muy Alto',color:'#a80000'},
            ]
        },
        {
            id:20,
            legendName:'Luces Nocturnas</br>compuesto 2016</br> promedio de la radianza',
            legend:[
            {key:'0',color:'#000000'},
            {key:'0.0 - 0.15',color:'#686868'},
            {key:'0.15 - 0.25',color:'#002573'},
            {key:'0.25 - 0.50',color:'#0085a8'},
            {key:'0.50 - 1.50',color:'#56fa5d'},
            {key:'1.50 - 10',color:'#ffff00'},
            {key:'10 - 50',color:'#e59800'},
            {key:'50 - 75',color:'#e54c00'},
            {key:'> 75',color:'#a80000'}
            ]
        },
        {
            id:21,
            legendName:'Luces Nocturnas compuesto 2016</br> promedio de la radianza',
            legend:[
            {key:'0',color:'#000000'},
            {key:'0.0 - 0.15',color:'#686868'},
            {key:'0.15 - 0.25',color:'#002573'},
            {key:'0.25 - 0.50',color:'#0085a8'},
            {key:'0.50 - 1.50',color:'#56fa5d'},
            {key:'1.50 - 10',color:'#ffff00'},
            {key:'10 - 50',color:'#e59800'},
            {key:'50 - 75',color:'#e54c00'},
            {key:'> 75',color:'#a80000'}
            ]
        },
        {
            id:22,
            legendName:'Áreas Naturales Protegidas (ANP\'s)',
            legend:[
            {key:'<img style="width: 230px;" src="static/png/anp.png" />',color:''}
            ]
        },
        {
            id:23,
            legendName:'Centros regionales de manejo</br>del fuego (CONAFOR)',
            legend:[
            {key:'Noroeste',color:'#fe9659'},
            {key:'Norte',color:'#c4e437'},
            {key:'Noreste',color:'#89cd66'},
            {key:'Occidente',color:'#6dd0e1'},
            {key:'Centro',color:'#7c65cd'},
            {key:'Sureste',color:'#fc75dd'}
            ]
        },
        {
            id:24,
            legendName:'Áreas Prioritarias de protección</br>contra incendios forestales</br>(CONAFOR)',
            legend:[
            {key:'Baja prioridad',color:'#39a602'},
            {key:'Media prioridad',color:'#effa38'},
            {key:'Alta prioridad',color:'red'}
            ]
        },
        {
            id:25,
            legendName:'Fronteras',
            legend:[
            {key:'País',color:'#ce4b1b'},
            {key:'Estado',color:'#ffffff'}
            ]
        },
        {
            id:26,
            legendName:'Últimas imagénes recibidas',
            legend:[
                {key:'Mosaico MODIS en color verdadero con</br>resolución de 250 metros',color:''}
            ]
        },
        {
            id:27,
            legend:[
                {key:'Mosaico VIIRS en color verdadero con</br>resolución de 375 metros (RGB:l-11,l-02,l-01).',color:''}
            ]
        },
        {
            id:28,
            legendName:'Últimas imagénes recibidas',
            legend:[
                {key:'Mosaico VIIRS nocturno con</br>resolución de 1,000 metros (RGB:DNB).',color:''}
            ]
        },
        {
            id:100,
            legendName:'Vientos derivados de GOES-19 ABI</br>Presión atmosférica (hPa)',
            legend:[
                {key:'118 - 294',color:'#fcfdbf'},
                {key:'294 - 471',color:'#fb8761'},
                {key:'471 - 647',color:'#b6367a'},
                {key:'647 - 824',color:'#50127b'},
                {key:'>824',color:'#0d0887'},
                {key:'</br>Velocidad',color:''},
                {key:'<img style="width: 200px; height: 90px;" src="static/png/wind_barbs.png" />',color:''}
            ]
        },
        {
            id:101,
            legendName:'Total de energía estimada </br>GOES-19 GLM (2km)',
            legend:[
                {key:'Baja',color:'#0868ac'},
                {key:'',color:'#43a2ca'},
                {key:'Moderada',color:'#7bccc4'},
                {key:'',color:'#bae4bc'},
                {key:'Alta',color:'#f0f9e8'}
            ]
        },
        {
            id:102,
            legendName:'Precipitación estimada</br>GOES-19 ABI(2km)</br>Precipitación (mm/h):',
            legend:[
                {key:'0',color:'#30123b'},
                {key:'11',color:'#4662d8'},
                {key:'22',color:'#35abf8'},
                {key:'33',color:'#1be5b5'},
                {key:'44',color:'#74fe5d'},
                {key:'56',color:'#c9ef34'},
                {key:'67',color:'#fbb938'},
                {key:'78',color:'#f56918'},
                {key:'89',color:'#c92903'},
				{key:'>100',color:'#7a0403'}
            ]
        },
        {
            id:103,
            legendName:'% de humedad de<br>combustible muerto',
            legend:[
                {key:'0',color:'#ffffff'},
                {key:'1-3',color:'#ffff73'},
                {key:'3-5',color:'#ffffbe'},
                {key:'5-8',color:'#beffe8'},
                {key:'8-11',color:'#bee8ff'},
                {key:'11-15',color:'#00c3ff'},
                {key:'15-21',color:'#006eff'},
                {key:'21-25',color:'#004da8'},
                {key:'> 25',color:'#002673'}
            ]
        },
        {
            id:104,
            legendName:'Capa de Calidad <br> (Día de registro de datos)',
            legend:[
                {key:'datos del día',color:'#440154'},
                {key:'1 día atrás',color:'#46327f'},
                {key:'2 días atrás',color:'#365c8d'},
                {key:'3 días atrás',color:'#277f8e'},
                {key:'4 días atrás',color:'#1fa288'},
                {key:'5 días atrás',color:'#4ac26d'},
                {key:'6 días atrás',color:'#9ed93a'},
                {key:'Climatología',color:'#fde725'}
            ]
        },
        {
            id:29,
            legendName:'Áreas quemadas (AQ)<br>(500 metros)',
            legend:[
                {key:'Polígono de área quemada',color:'#b07d40'}
            ]
        },
        {
            id:30
        },
        {
            id:31
        },
        {
            id:32,
            legendName:'Filtro (*Tres meses)',
            legend:[
                {key:'< 1 día',color:'#800026'},
                {key:'< 2 día',color:'#bd0026'},
                {key:'< 3 día',color:'#e31a1c'},
                {key:'< 4 día',color:'#fc4e2a'},
                {key:'< 5 día',color:'#fd8d3c'},
                {key:'< 6 día',color:'#feb24c'},
                {key:'< 7 día',color:'#fed976'},
                {key:'< 8 día',color:'#ffeda0'},
                {key:'< 9 día',color:'#ffffcc'},
				{key:'< 10 día',color:'#808080'}
            ]
        },
        {
            id:33,
            legendName:'Estados test',
            legend:[
                {key:'Polígono de áreas quemadas',color:'#b07d40'}
            ]
        },
        {
            id:34,
            legendName:'Estados test',
            legend:[
                {key:'Polígono de áreas quemadas',color:'#b07d40'}
            ]
        },
        {
            id:35,
            legendName:'Estados test',
            legend:[
                {key:'Polígono de áreas quemadas',color:'#b07d40'}
            ]
        },
        {
            id:36,
            legendName:'Últimas imagénes recibidas',
            legend:[
                {key:'Mosaico GOES-19  ABI, falso color <br>con resolución de 500 metros. <br>(RGB: B02, B03, B05)',color:'#b07d40'}
            ]
        },
        {
            id:37,
            legendName:'Últimas imagénes recibidas',
            legend:[
                {key:'Mosaico GOES-19  ABI, color verdadero <br>con resolución de 500 metros. <br>(RGB: B01, Pseudo Green, B02)',color:'#b07d40'}
            ]
        },
        {
            id:50,
            legendName:'Estadísticas',
            nivel:[{
                id:3,
                legend:[
                    {key:'Alto',color:'#863528'},
                    {key:'Medio',color:'#977a42'},
                    {key:'Bajo',color:'#ccc086'},
                ]
            },
            {   id:5,
                legend:[
                    {key:'Muy Alto',color:'#79272f'},
                    {key:'Alto',color:'#863528'},
                    {key:'Medio',color:'#977a42'},
                    {key:'Bajo',color:'#ccc086'},
                    {key:'Muy Bajo',color:'#c9c88c'}
                ]
            }]
        },
        ,
        {
            id:60,
            legendName:'Filtro (*Tres meses)',
            legend:[
                {key:'< 1 día',color:'#800026'},
                {key:'< 2 día',color:'#bd0026'},
                {key:'< 3 día',color:'#e31a1c'},
                {key:'< 4 día',color:'#fc4e2a'},
                {key:'< 5 día',color:'#fd8d3c'},
                {key:'< 6 día',color:'#feb24c'},
                {key:'< 7 día',color:'#fed976'},
                {key:'< 8 día',color:'#ffeda0'},
                {key:'< 9 día',color:'#ffffcc'},
				{key:'< 10 día',color:'#808080'}
            ]
        },
        {
            id:61,
            legendName:'Datos Históricos Mensuales<br>Puntos de calor',
            legend:[
                {key:'Agrícultura',color:'#FFD37F'},
                {key:'Asentamientos humanos',color:'#E1E1E1'},
                {key:'Coníferas',color:'#38A800'},
                {key:'Coníferas y latifoliadas',color:'#4CE600'},
                {key:'Cuerpo de Agua',color:'#00C5FF'},
                {key:'Desprovisto de Vegetación <br>o Sin Vegetación Aparente',color:'#FFFFFF'},
                {key:'Latifoliadas',color:'#9BDE00'},
                {key:'Manglar',color:'#008A9E'},
                {key:'Otras Asociaciones <br>y Áreas Forestales',color:'#7D990F'},
                {key:'Pastizal Cultivado',color:'#FFFF00'},
                {key:'Selvas Altas y Medias',color:'#A900FF'},
                {key:'Selvas Bajas',color:'#F770FF'},
                {key:'Zonas Urbanas',color:'#E1E1E1'},
                {key:'Zonas Semiáridas',color:'#E39C1C'},
                {key:'Zonas Áridas',color:'#D44C00'}
            ]
        },
        {
            id:62,
            legendName:'Datos históricos mensuales<br>Áreas quemadas(500 m) MODIS',
            legend:[
                {key:'Polígono de área quemada',color:'#b07d40'}
            ]
        },
        {
            id:88,
            legendName:'Áreas quemadas (AQ)<br>(500 metros)',
            legend:[
                {key:'Polígono de área quemada',color:'#b07d40'}
            ]
        },
        {
            id:89,
            legendName:'Áreas quemadas (AQ)<br>(500 metros)',
            legend:[
                {key:'Polígono de área quemada',color:'#b07d40'}
            ]
        },
        {
            id: 105,
            legendName:'Puntos de calor',
            name:'P. Calor GOES',
            legend:[{key:'P. Calor GOES',color:'#e74c3c'}]
        },
        {
            id: 106,
            legendName:'Puntos de calor Heatmap',
            name:'P. Calor GOES',
            legend:[{key:'P. Calor GOES',color:'#e74c3c'}]
        },
        {
            id: 108,
            legendName:'Puntos de calor',
            name:'P. Calor GOES',
            legend:[{key:'P. Calor GOES',color:'#e74c3c'}]
            //legend:[{key:'0-20',color:'#faebdd'},
            //{key:'20-50',color:'#f58860'},
            //{key:'50-100',color:'#cb1b4f'},
            //{key:'100-200',color:'#611f53'},
            //{key:'200-300',color:'#03051a'}]
        },
        {
            id: 109,
            legendName:'Puntos de calor Heatmap',
            name:'P. Calor GOES',
            legend:[{key:'P. Calor GOES',color:'#e74c3c'}]
        },
        {
            id:120,
            legendName:'Emisiones <br> CO2 (e3 kg)',
            legend:[
                {key:'0-50',color:'#2b83ba'},
                {key:'50-100',color:'#5aa4b2'},
                {key:'100-200',color:'#88c4aa'},
                {key:'200-300',color:'#b3e0a6'},
                {key:'300-400',color:'#d1ecb0'},
                {key:'400-500',color:'#f0f9ba'},
                {key:'500-600',color:'#fff0ae'},
                {key:'600-700',color:'#fed38c'},
                {key:'600-800',color:'#fdb56a'},
                {key:'800-900',color:'#f3854e'},
                {key:'900-1000',color:'#e54f35'},
                {key:'>1000',color:'#820dbc'},
            ]
        },{
            id:121,
            legendName:'Emisiones <br> CO2 (e3 kg)',
            legend:[
                {key:'0-50',color:'#2b83ba'},
                {key:'50-100',color:'#5aa4b2'},
                {key:'100-200',color:'#88c4aa'},
                {key:'200-300',color:'#b3e0a6'},
                {key:'300-400',color:'#d1ecb0'},
                {key:'400-500',color:'#f0f9ba'},
                {key:'500-600',color:'#fff0ae'},
                {key:'600-700',color:'#fed38c'},
                {key:'600-800',color:'#fdb56a'},
                {key:'800-900',color:'#f3854e'},
                {key:'900-1000',color:'#e54f35'},
                {key:'>1000',color:'#820dbc'},
            ]
        },
        {
            id:122,
            legendName:'Presión del fuego',
            legend:[
                {key:'Baja frecuencia e intervalo largo',color:'#ffffb2'},
                {key:'Baja frecuencia e intervalo corto',color:'#fecc5c'},
                {key:'Alta frecuencia e intervalo largo',color:'#fd8d3c'},
                {key:'Alta frecuencia e intervalo corto',color:'#e31a1c'}
            ]
        },
    ]
    